import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../Auth';
import LogoutButton from './LogoutButton';

const Footer = () => {
  const { isAuthenticated } = useAuth();

  return (
    <footer className="bg-white border-t border-gray-200 py-6">
      <div className="container mx-auto px-4 text-center text-sm text-gray-500 space-y-1">
        <p>Born from the frustration of overly complicated and expensive event sites.</p>
        <p className="text-gray-400">
          Gatherly · Since 2024 · An often forgotten project by{' '}
          <a 
            href="https://joshuamanning.com" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-700 hover:underline"
          >
            Josh Manning
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;